import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "./Loader.module.scss";

const Loader = (props) => (
  <div className={styles["loader-wrapper"]}>
    <CircularProgress {...props} />
  </div>
);

Loader.defaultProps = {
  size: 30
};

export default Loader;
